import { Dispatch } from 'redux';
import { StepDispatchTypes, STEP_1, STEP_CLEAR } from './AddSourceAccountStepTypes';

export const stepOne =
  (data: object) => async (dispatch: Dispatch<StepDispatchTypes>) => {
    dispatch({
      type: STEP_1,
      data,
    });
};

export const stepClear =
  () => async (dispatch: Dispatch<StepDispatchTypes>) => {
    dispatch({
      type: STEP_CLEAR
    });
};
